module.exports = __webpack_public_path__ + "img/hungary-logo-icon.ce23e49a.png";